import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translations
import enTranslations from './locales/en.json'

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Only English is supported for now
    fallbackLng: 'en',
    supportedLngs: ['en'],
    
    // Resources with translations
    resources: {
      en: {
        translation: enTranslations,
      },
    },

    // Default namespace
    defaultNS: 'translation',

    // React options
    react: {
      useSuspense: false,
    },

    // Debug mode (disable in production)
    debug: import.meta.env.DEV,

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  })

export default i18n
